import { render, staticRenderFns } from "./PaymentGuide.vue?vue&type=template&id=1dd5acb1&scoped=true&"
import script from "./PaymentGuide.vue?vue&type=script&lang=js&"
export * from "./PaymentGuide.vue?vue&type=script&lang=js&"
import style0 from "./PaymentGuide.vue?vue&type=style&index=0&id=1dd5acb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd5acb1",
  null
  
)

export default component.exports